import React from 'react';
import {
  Visibility,
  Message,
  VideoLibrary,
  AttachFile,
  Flag,
} from '@mui/icons-material';

export const getNotificationIcon = (notificationSource) => {
  switch (notificationSource) {
    case 'patientMessage':
    case 'doctorMessage':
    case 'teacherMessage':
    case 'studentMessage':
    case 'groupMessage':
      return <Message sx={{ fontSize: 20, color: '#9291ef' }} />;
    case 'patientVideoUploaded':
    case 'doctorVideoUploaded':
    case 'teacherVideoUploaded':
    case 'studentVideoUploaded':
    case 'uploadVideo':
      return <VideoLibrary sx={{ fontSize: 20, color: '#9291ef' }} />;
    case 'patientDocumentUploaded':
    case 'doctorDocumentUploaded':
    case 'teacherDocumentUploaded':
    case 'studentDocumentUploaded':
    case 'patientAttachmentUploaded':
    case 'doctorAttachmentUploaded':
    case 'teacherAttachmentUploaded':
    case 'studentAttachmentUploaded':
      return <AttachFile sx={{ fontSize: 20, color: '#9291ef' }} />;
    case 'patientGoalCreated':
    case 'doctorGoalCreated':
    case 'teacherGoalCreated':
    case 'studentGoalCreated':
    case 'patientBehaviorCreated':
    case 'doctorBehaviorCreated':
    case 'teacherBehaviorCreated':
    case 'studentBehaviorCreated':
      return <Flag sx={{ fontSize: 20, color: '#9291ef' }} />;
    case 'newPatientReg':
      return <Visibility sx={{ fontSize: 20, color: '#9291ef' }} />;
    default:
      return <Message sx={{ fontSize: 20, color: '#9291ef' }} />;
  }
}; 